import { OverclaimWorkSearchQuery } from '@App/stores/search/models/overclaim-search'

const documentationStatusIds: Record<string, string> = {
    DOCUMENT_NEEDED: '10',
    DOCUMENT_PENDING: '20',
    DOCUMENT_ACCEPTED: '40',
}
const amendmentStatusIds: Record<string, string> = {
    AMENDMENT_NEEDED: '10',
    AMENDMENT_PENDING: '20',
    AMENDMENT_ACCEPTED: '40',
}

const statusIds = (values: string[] | undefined, ids: Record<string, string>): string[] | undefined =>
    values?.length
        ? values.map((value) => {
              const id = ids[value]
              if (!id) {
                  throw new Error(`Unsupported Overclaim export filter: ${value}`)
              }
              return id
          })
        : undefined

export class OverclaimReportRequestDTO {
    format: string
    overclaimId?: string
    title?: string
    songCode?: string
    overclaimTypeFilters?: string[]
    overclaimStatusFilters?: string[]
    overclaimDocumentationFilters?: string[]
    overclaimAmendmentFilters?: string[]

    constructor(query: OverclaimWorkSearchQuery, format: string) {
        this.format = format
        this.overclaimId = query.overclaimHeaderId == null ? undefined : String(query.overclaimHeaderId)
        this.title = query.title
        this.songCode = query.mlcSongCode
        this.overclaimStatusFilters = query.status?.length ? [...query.status] : undefined
        this.overclaimDocumentationFilters = statusIds(query.documentationStatus, documentationStatusIds)
        this.overclaimAmendmentFilters = statusIds(query.amendmentStatus, amendmentStatusIds)
    }
}
